import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Typography } from '@americanexpress/aqx-components';
import styles from './styles.scss?modules';
import { getActiveFilter } from 'src/universal/redux/cardsFilter';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

const SeoCategory = ({ data, activeFilter }) => {
  if (activeFilter === 'all-cards' || activeFilter === 'recommended') {
    return null;
  }
  const filterData = parseArrayToObject(data?.content, 'filterName')[activeFilter];

  const seoRef = useRef(null);

  const clickHandler = e => {
    if (e.target.tagName === 'A' && filterData?.dtm) {
      sendDTMClickEvent(filterData.dtm);
    }
  };

  useEffect(
    () => {
      if (seoRef?.current) {
        seoRef.current.addEventListener('click', clickHandler);
        return () => {
          seoRef.current.removeEventListener('click', clickHandler);
        };
      }
    },
    [activeFilter]
  );

  return (
    <div ref={seoRef} className={styles.seoBox}>
      <h4>{filterData?.title}</h4>
      <div className={styles.seoTileBox}>
        {filterData?.tiles.map((eachTile, index) => {
          return (
            <div key={index} className={styles.seoTile}>
              <Typography className={styles.seoTileTitle}>
                {eachTile?.tileTitle}
              </Typography>
              <Typography className={styles.seoTileDesc}>
                {eachTile?.tileDesc}
              </Typography>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    activeFilter: getActiveFilter(state)
  };
};

export default connect(mapStateToProps)(SeoCategory);
